import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { validateEmail } from '../helpers'
import TextField from '../../../../../FormLegacy/FormFieldsV2/TextField'

const NonResidentView = ({
  formState = {},
  handleFieldChange = () => {},
  setIsValidEmail = () => {},
  isValidEmail,
}) => {
  const { t } = useTranslation(['rewards-gift'])
  return (
    <React.Fragment>
      <div className="rewards-modal-input-row">
        <div className="input-container">
          <div className="input-label">{t('rewards-gift:nonResidentView.recipientNameLabel')}</div>
          <TextField
            name="recipientName"
            onChange={handleFieldChange}
            value={formState.recipientName}
            placeholder={t('rewards-gift:nonResidentView.enterRecipientNamePlaceholder')}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <div className="rewards-modal-input-row">
        <div className="input-container">
          <div className="input-label">{t('rewards-gift:nonResidentView.recipientEmailLabel')}</div>
          <TextField
            name="recipientEmail"
            onChange={handleFieldChange}
            onBlur={(e) => setIsValidEmail(validateEmail(e.target.value))}
            value={formState.recipientEmail}
            placeholder={t('rewards-gift:nonResidentView.enterRecipientEmailPlaceholder')}
            style={{ width: '100%' }}
            errorLabel={t('rewards-gift:nonResidentView.invalidEmailError')}
            isError={!isValidEmail}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

NonResidentView.propTypes = {
  formState: PropTypes.object,
  handleFieldChange: PropTypes.func,
  setIsValidEmail: PropTypes.func,
  isValidEmail: PropTypes.bool,
}

export default NonResidentView
